(function () {
    //'use strict';

    angular
        .module('app')
        .controller('flashEditForecasting', flashEditForecasting);

    function flashEditForecasting($scope, $rootScope, $state, $filter, ForecastingService, SeasonService, PrototypeService,
        PatternService, SharedData, LinePlanService, cfpLoadingBar, toaster, GridUtil) {
        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }


        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 16) {
                if (userPermissionRow[1] == 2) {
                    model.ForecastEdit = true;
                }
            }
        });

        if (!model.ForecastEdit) {
            $state.go('permissionDenied');
        }

        $scope.brands = [];
        $scope.seasons = [];
        $scope.genders = [];
        $scope.factories = [];
        $scope.lineplans = [];

        $scope.cellEditors = {
            'customCellEditor': customCellEditor
        };

        $scope.cellRenderers = {
            'currencyRenderer': currencyRenderer,
            'numberRenderer': numberRenderer
        };

        $scope.valueFormatters = {
            'numberRenderer': numberRenderer
        };

        var globalPageNumber = 1;
        var globalPageSize = 50;

        $scope.windowGridHeight = function () {
            if (window.outerHeight >= 768) {
                return window.innerHeight - 315;
            } else {
                var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                return (size * gridOptions.rowHeight) + 46;
            }
        };

        $scope.doSave = function (params) {
            if (params.colDef.field == 'Launch') {
                ForecastingService.getLinePlanLaunchDateId(params.data.PrototypeSeasonalId, params.newValue).then(function (response) {
                    if (response > 0) {
                        params.data.LinePlanLaunchDateId = response;
                        $scope.calcTotalVolumes(params);
                        $scope.saveEdits(params.data);
                    }
                    else {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'Invalid Launch Number',
                            timeout: 5000
                        });
                    }
                });
            }
            else {
                $scope.calcTotalVolumes(params);
                $scope.saveEdits(params.data);
            }
        };

        $scope.saveEdits = function (data) {

            var fcast = {
                PrototypeSeasonalId: data.PrototypeSeasonalId,
                PrototypeId: data.PrototypeId,
                PrototypeName: data.PrototypeName,
                SeasonId: data.SeasonId,
                SAPSeasonCode: data.SAPSeasonCode,
                StatusName: data.StatusName,
                Gender: data.Gender,
                StockNum: data.StockNum,
                FactName: data.FactName,
                CtryOfOrig: data.CtryOfOrig,
                ColorDesc: data.ColorDesc,
                USVolume: data.USVolume,
                NaDtcStoreVolume: data.NaDtcStoreVolume,
                NaDtcEcomVolume: data.NaDtcEcomVolume,
                ItalyVolume: data.ItalyVolume,
                CAVolume: data.CAVolume,
                EmeaOwnedVolume: data.EmeaOwnedVolume,
                EmeaDistVolume: data.EmeaDistVolume,
                EuDtcVolume: data.EuDtcVolume,
                Emea3pVolume: data.Emea3pVolume,
                AsiaVolume: data.AsiaVolume,
                CNVolume: data.CNVolume,
                HKVolume: data.HKVolume,
                C4CVolume: data.C4CVolume,
                LatinAVolume: data.LatinAVolume,
                IntnlVolume: data.IntnlVolume,
                TotalVolume: data.TotalVolume,
                ActPurPrice: data.ActPurPrice,
                EstPurPrice: data.EstPurPrice,
                RetailPrice: data.RetailPrice,
                WsPrice: data.WsPrice,
                Launch: data.Launch,
                LinePlanLaunchDateId: data.LinePlanLaunchDateId,
            };

            //send the data object to the API
            ForecastingService.updateProtoForecast(fcast).then(function (response) {

            }, function (error, report) {
                toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error performing the update: ' + error, timeout: 5000 });
            });
        };

        function parseVolume(volumeVal) {
            if (isNaN(volumeVal) || volumeVal == null) {
                volumeVal = 0;
            }
            else if (volumeVal.toString().trim() == "") {
                volumeVal = 0;
            }

            return parseFloat(volumeVal);
        };

        $scope.calcTotalVolumes = function (params) {
            //cols
            var colName1 = 'TotalVolume',
                colName2 = 'IntnlVolume';

            var IntlVolume = parseVolume(params.data.AsiaVolume) +
                parseVolume(params.data.Emea3pVolume) +
                parseVolume(params.data.LatinAVolume);

            var TotVolume = parseVolume(params.data.USVolume) +
                parseVolume(params.data.NaDtcStoreVolume) +
                parseVolume(params.data.NaDtcEcomVolume) +
                parseVolume(params.data.CAVolume) +
                parseVolume(params.data.EmeaOwnedVolume) +
                parseVolume(params.data.EmeaDistVolume) +
                parseVolume(params.data.EuDtcVolume) +
                IntlVolume;

            //make row editable for a brief moment to update the grid
            var col1 = gridOptions.columnApi.getColumn(colName1);
            var colDef1 = col1.getColDef();

            var rowNode = gridOptions.api.getRowNode(params.node.data.PrototypeSeasonalId);
            rowNode.setDataValue(colName1, TotVolume);
            rowNode.setDataValue(colName2, IntlVolume);
        };

        $scope.pagingOptions = [15, 25, 50, 100];

        $scope.onBtnBeg = function () {
            $scope.pageNumber = 1;
            $scope.onPageChanged(1);
        };

        $scope.onBtnEnd = function () {
            $scope.pageNumber = $scope.totalPages;
            $scope.onPageChanged($scope.totalPages);
        };

        $scope.onBtnPrev = function (e) {
            if (e > 1) {
                e = e - 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onBtnNext = function (e) {
            if (e < $scope.totalPages) {
                e = e + 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onPageChanged = function (e) {
            globalPageNumber = e;
            $scope.flashEditForecasting.$pristine = false; //forces the search to get new results
            $scope.getForecast();
        };

        $scope.onPageSizeChanged = function (e) {
            globalPageSize = e;
            globalPageNumber = 1;
            $scope.getForecast();
        };

        function valueConvert(n) {
            if (n !== '' && n !== null && n !== true && n !== false) {
                if (!isNaN(n)) {
                    return parseInt(n);
                }
            }
            if (n == null || n == '') {
                return '';
            }
            return n;
        }

        //define custom editor class
        function customCellEditor() {
        }

        customCellEditor.prototype.init = function (params) {
            this.params = params;
            this.eInput = document.createElement('input');
            this.eInput.className = 'ag-cell-edit-input';
            this.eInput.maxLength = '8'; //set maxlength for editing db is an INT so go nuts
            this.eInput.type = 'text';

            //assignment back from API changes or a direct input change
            if (params.charPress) {
                var number = parseInt(params.charPress);
                if (!isNaN(number))
                    this.eInput.value = params.charPress;
            } else {
                this.eInput.value = params.value;
            }

            this.eInput.addEventListener('keydown', function (event) {
                var value = this.value;

                //backspace, tab, up, down, left, right arrows, enter, period, period_num_pad,
                var allowedKeys = [8, 13, 37, 38, 39, 40, 46, 190, 110];
                var allowedMetaKeys = [65, 86, 67, 88, 116, 82, 90];
                //Ctrl, Ctrl + A, Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + R, Ctrl + Z
                var eventKey = event.key;

                var isThisLaunch = false;
                if (params.column.colId == 'Launch') {
                    isThisLaunch = true;
                }

                //no spacebar
                if (eventKey == " ") {
                    eventKey = 'x';
                    //just defaulting it to a value that isnt allowed
                }

                if (isNaN(eventKey)) {
                    var ctrlMeta = event.ctrlKey == true || event.metaKey == true;
                    //if ctrl isnt being pressed
                    if (!ctrlMeta) {
                        if (allowedKeys.indexOf(event.keyCode) == -1) {
                            event.preventDefault();
                        }
                        if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                            event.preventDefault();
                        }
                    }
                } else {
                    var ek = event.key;
                    var pf = parseFloat(value + ek);
                    if (isThisLaunch && (pf > 8 || pf < 1)) {
                        event.preventDefault();
                    }
                }
            });
        }

        customCellEditor.prototype.getGui = function () {
            return this.eInput;
        };

        // focus and select can be done after the gui is attached
        customCellEditor.prototype.afterGuiAttached = function () {
            var l = this.eInput.value ? this.eInput.value.toString().length : '';

            this.eInput.value = this.eInput.value;

            if (!this.params.charPress) {
                this.eInput.setSelectionRange(0, l);
            } else {
                if (l !== "") {
                    this.eInput.setSelectionRange(l, l);
                }
            }
            this.eInput.focus();
        };

        // returns the new value after editing
        customCellEditor.prototype.isCancelBeforeStart = function () {
            return this.cancelBeforeStart;
        };

        // returns the new value after editing
        customCellEditor.prototype.getValue = function () {
            return this.eInput.value;
        };

        function currencyRenderer(params) {
            return $filter('currency')(params.value);
        }

        function numberRenderer(params) {
            return $filter('number')(params.value);
        }

        var widthXS = 65;
        var widthS = 105;
        var widthM = 160;
        var widthL = 210;
        var widthXL = 350;
        var globalRowHeight = 30;
        var widthImage = 76;

        //build gridoptions, build columns
        var gridOptions = {
            columnDefs: null,
            rowHeight: globalRowHeight,
            enableColResize: true,
            enableFilter: false,
            enableSorting: false,
            enableServerSideSorting: true,
            paginationPageSize: globalPageSize,
            suppressContextMenu: true,
            suppressMultiSort: true,
            suppressSorting: false,
            suppressDragLeaveHidesColumns: true,
            suppressMovableColumns: true, //set to false to stop from moving colums
            suppressRowHoverClass: true,
            suppressColumnMoveAnimation: true,
            suppressColumnVirtualisation: true,
            showToolPanel: false,
            stopEditingWhenGridLosesFocus: true,
            getRowNodeId: function (data) { return data.PrototypeSeasonalId; },
            onCellValueChanged: function (params) {
                var oldValue = valueConvert(params.oldValue);
                var newValue = valueConvert(params.newValue);

                if (oldValue !== newValue && params.colDef.field !== 'IntnlVolume' && params.colDef.field !== 'TotalVolume') {
                    $scope.doSave(params);
                }
            },
            onCellClicked: function (params) {
                if (params.colDef.colorwayLink) {
                    $state.go('colorway', { 'prototypeSeasonalId': params.data.PrototypeSeasonalId });
                }
            },

            onSortChanged: function (e) {
                var sortObj = gridOptions.api.getSortModel();
                $scope.searchForm.sortColumn = sortObj.length ? sortObj[0].colId : "";
                $scope.searchForm.sortDirection = sortObj.length ? sortObj[0].sort : "";

                $scope.getForecast();
            }
        };

        $scope.exportData = function () {
            //This way of exporting doesn't know what is visible in the grid so we need to format before exporting.
            //Also it will export nulls, which looks nasty.
            var tempData = [];
            for (var i in $scope.gridData) {
                var row = $scope.gridData[i];
                var temp = {};

                temp.PrototypeSeasonalId = row.PrototypeSeasonalId || "";
                temp.PrototypeName = row.Name || "";
                temp.StockNum = row.StockNum || "";
                temp.SAPSeasonCode = row.SAPSeasonCode || "";
                temp.StatusName = row.StatusName || "";
                temp.Gender = row.Gender || "";
                temp.FactName = row.FactName || "";
                temp.FactoryGroupName = row.FactoryGroupName || "";
                temp.CtryOfOrig = row.CtryOfOrig || "";
                temp.ColorDesc = row.ColorDesc || "";

                if ($scope.region === "NA" || $scope.region === "ALL") {
                    temp.USVolume = row.USVolume || "";
                    temp.NaDtcStoreVolume = row.NaDtcStoreVolume || "";
                    temp.NaDtcEcomVolume = row.NaDtcEcomVolume || "";
                    temp.CAVolume = row.CAVolume || "";
                }
                if ($scope.region === "EMEA" || $scope.region === "ALL") {
                    temp.EmeaOwnedVolume = row.EmeaOwnedVolume || "";
                    temp.EmeaDistVolume = row.EmeaDistVolume || "";
                    temp.EuDtcVolume = row.EuDtcVolume || "";
                    temp.Emea3pVolume = row.Emea3pVolume || "";
                    temp.ItalyVolume = row.ItalyVolume || "";
                    temp.Emea3pVolume = row.Emea3pVolume || "";
                }
                if ($scope.region === "LAAP" || $scope.region === "ALL") {
                    temp.AsiaVolume = row.AsiaVolume || "";
                    temp.CNVolume = row.CNVolume || "";
                    temp.HKVolume = row.HKVolume || "";
                    temp.C4CVolume = row.C4CVolume || "";
                    temp.LatinAVolume = row.LatinAVolume || "";
                }

                if ($scope.region === "ALL") {
                    temp.Launch = row.Launch || "";
                }

                temp.IntnlVolume = row.IntnlVolume || "";
                temp.TotalVolume = row.TotalVolume || "";
                temp.EstPurPrice = row.EstPurPrice || "";
                temp.ActPurPrice = row.ActPurPrice || "";

                tempData.push(temp);
            }

            alasql.promise('SELECT * INTO XLSX("PLM_Prototype_Forecasting_Export.xlsx",{headers:true,sheetid:"Sheet1"}) FROM ?', [tempData])
                .then(function (data) {
                    //custom loader bar complete so we can make sure the grid is visible and rendered before hiding the loader
                    cfpLoadingBar.complete();
                }).catch(function (err) {
                });
        };

        var FCols = [
            'USVolume', 'NaDtcStoreVolume', 'NaDtcEcomVolume', 'ItalyVolume', 'CAVolume', 'EmeaOwnedVolume', 'EmeaDistVolume', 'EuDtcVolume', 'Emea3pVolume', 'AsiaVolume', 'CNVolume', 'HKVolume', 'C4CVolume', 'LatinAVolume', 'IntnlVolume', 'Launch',
        ];

        $scope.columnsSet = function (arr, tf) {
            for (var i = 0; i < arr.length; i++) {
                gridOptions.columnApi.setColumnVisible(arr[i], tf);
            }
        };

        $scope.setRegionVisibility = function (region) {
            $scope.region = region;
            switch (region) {
                case "NA":
                    $scope.columnsSet(FCols, false);
                    $scope.columnsSet(['USVolume', 'NaDtcStoreVolume', 'NaDtcEcomVolume', 'CAVolume'], true);
                    break;
                case "EMEA":
                    $scope.columnsSet(FCols, false);
                    $scope.columnsSet(['EmeaOwnedVolume', 'EmeaDistVolume', 'EuDtcVolume', 'ItalyVolume', 'Emea3pVolume'], true);
                    break;
                case "LAAP":
                    $scope.columnsSet(FCols, false);
                    $scope.columnsSet(['AsiaVolume', 'CNVolume', 'HKVolume', 'C4CVolume', 'LatinAVolume'], true);
                    break;
                case "ALL":
                    $scope.columnsSet(FCols, true);
                    break;
                default:
                    $scope.columnsSet(FCols, true);
            }
        };

        //Upload functions
        $scope.documentInterface = {};
        $scope.massForecastMetaData = {};

        $scope.selectDoc = function (e) {
            if (e.files.length > 0)
                uploadDoc(e.files[0], 'browse');
        };

        $scope.addDoc = function (file) {
            uploadDoc(file.file, 'dragdrop');
        };

        function clearFileSelect() {
            $scope.documentInterface = {};
            document.getElementById('file').value = null;
        }

        function uploadDoc(file, source) {
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
            if (ext != "xls" && ext != "xlsx") {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: "Please upload an Excel file (.xls or .xlsx)",
                    timeout: 5000
                });
                clearFileSelect();
                return;
            }

            ForecastingService.uploadMassPrototypeForecastDocument(file)
                .then(function (response) {
                    toaster.pop({ type: 'success', title: 'Forecasting upload complete!', body: 'You will be notified by email when processing is complete.', timeout: 5000 });

                    clearFileSelect();
                }, function (error, status) {
                    toaster.pop({ type: 'error', title: 'Forecasting upload failed', body: 'Contact system administrator.', timeout: 5000 });
                    clearFileSelect();
                });
            $scope.showSearchForm = true;
            $scope.showGrid = false;
        }

        //getPage();

        function getPage() {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    $scope.searchForm = {};
                    $scope.brands = response.brands;
                    $scope.seasons = response.seasons;
                    $scope.searchForm.brandId = response.brandId;
                    $scope.searchForm.seasonId = response.seasonId;
                    $scope.searchForm.divisionKey = response.divisionKey;
                    $scope.getLinePlans($scope.searchForm.brandId, $scope.searchForm.seasonId, 0);
                }
                else {
                    console.log('Error getting shared data');
                }
            });

            $scope.showSearchForm = true;
            $scope.showGrid = false;
            getDivisions();
            getGenders();
            getFactories();
        };

        function setScopeLevelSearchInfo(response) {

            $scope.totalRecords = response.totalRecords;
            $scope.pageSize = response.pageSize;
            $scope.pageNumber = response.currentPage;
            $scope.totalPages = response.totalPages;

            $scope.lastRecord = $scope.pageNumber == $scope.totalPages
                ? $scope.totalRecords
                : $scope.pageNumber * $scope.pageSize;

            $scope.firstRecord = $scope.pageNumber == $scope.totalPages
                ? (($scope.pageNumber - 1) * $scope.pageSize) + 1
                : $scope.lastRecord - $scope.pageSize + 1;

            $scope.columnDefs = $scope.getColumnDefs(response);
        }

        function setGridSorting(columnDefs) {

            var colId = $scope.searchForm.sortColumn;
            var sort = $scope.searchForm.sortDirection;

            GridUtil.setSort(columnDefs, colId, sort);
        }

        function renderGrid(gridDiv, columnDefs, searchResults) {
            gridOptions.columnDefs = columnDefs;

            if (gridDiv.children.length == 0) {
                new agGrid.Grid(gridDiv, gridOptions);
            } else {
                gridOptions.api.setColumnDefs(gridOptions.columnDefs);
            }

            gridOptions.api.setRowData(searchResults);
            gridOptions.api.hideOverlay();
        }

        $scope.getColumnDefs = function (searchResponse) {
            var columnDefs = [];
            searchResponse.columnGroups.totalColumns = searchResponse.totalColumns;

            angular.forEach(searchResponse.columnGroups,
                function (colGroup) {
                    angular.forEach(colGroup.columns,
                        function (col) {

                            if (col.cellEditor) {
                                col.cellEditor = $scope.cellEditors[col.cellEditor];
                            }

                            if (col.cellRenderer) {
                                col.cellRenderer = $scope.cellRenderers[col.cellRenderer];
                            }

                            if (col.valueFormatter) {
                                col.valueFormatter = $scope.valueFormatters[col.valueFormatter];
                            }

                            columnDefs.push(col);
                        });
                });

            return columnDefs;
        };

        $scope.getForecast = function (exportResults) {

            var searchForm = {
                brandId: $scope.searchForm.brandId ? $scope.searchForm.brandId : null,
                seasonId: $scope.searchForm.seasonId ? $scope.searchForm.seasonId : null,
                projectName: $scope.searchForm.projectName ? $scope.searchForm.projectName : null,
                prototypeSeasonalId: $scope.searchForm.prototypeSeasonalId ? $scope.searchForm.prototypeSeasonalId : null,
                patternName: $scope.searchForm.patternName ? $scope.searchForm.patternName : null,
                statusId: $scope.searchForm.statusId ? $scope.searchForm.statusId : null,
                genderKey: $scope.searchForm.genderKey ? $scope.searchForm.genderKey : null,
                divisionKey: $scope.searchForm.divisionKey ? $scope.searchForm.divisionKey : null,
                divisionName: $scope.searchForm.divisionName ? $scope.searchForm.divisionName : null,
                factoryKey: $scope.searchForm.factoryKey ? $scope.searchForm.factoryKey : null,
                factoryName: $scope.searchForm.factoryName ? $scope.searchForm.factoryName : null,
                color: $scope.searchForm.color ? $scope.searchForm.color : null,
                stockNum: $scope.searchForm.stockNum ? $scope.searchForm.stockNum : null,
                LinePlanId: $scope.searchForm.LinePlanId ? $scope.searchForm.LinePlanId : null,
                pageNumber: exportResults ? '1' : globalPageNumber,
                pageSize: exportResults ? $scope.totalRecords : globalPageSize,
                sortColumn: $scope.searchForm.sortColumn,
                sortDirection: $scope.searchForm.sortDirection
            };

            cfpLoadingBar.start();
            model.exportResults = exportResults;

            ForecastingService.getProtoForecastList(searchForm).then(function (response) {
                if (!response || response.results.length === 0) {
                    cfpLoadingBar.complete();
                    toaster.pop({ type: 'alert', title: 'Warning!', body: 'No forecast data was found matching this search criteria.', timeout: 5000 });
                } else {
                    if (!model.exportResults) {
                        cfpLoadingBar.complete();

                        var gridDiv = document.querySelector('#myGrid');

                        setScopeLevelSearchInfo(response);

                        setGridSorting($scope.columnDefs);

                        renderGrid(gridDiv, $scope.columnDefs, response.results);

                        if (!$scope.region)
                            $scope.region = "NA";

                        $scope.setRegionVisibility($scope.region);

                        $scope.showGrid = true;
                        $scope.showSearchForm = false;


                        $scope.searchRan = true;
                        $scope.flashEditForecasting.$setPristine();
                    } else {
                        $scope.gridData = response.results;
                        $scope.exportData();
                    }
                }

            },
                function (error, status) {
                    toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error retrieving Forecasts. Please contact the system administrator', timeout: 5000 });
                });
        };

        $scope.toggleSearchAndResults = function () {
            if ($scope.showGrid) {
                $scope.showGrid = false;
                $scope.showSearchForm = true;
            } else {
                $scope.showGrid = true;
                $scope.showSearchForm = false;
            }
        };

        $scope.getSeason = function (brandId) {

            if (brandId) {
                SeasonService.getSeasonsByBrand(brandId).then(function (response) {
                    if (response) {
                        $scope.seasons = response;
                        $scope.noBrandSelected = false;
                    }
                });

            }
            else {
                $scope.seasons.length = 0;
                var season = { SeasonId: 0, Description: '-- Select Season --' };
                $scope.seasons.push(season);
                $scope.noBrandSelected = true;
            }
        };

        $scope.getLinePlans = function (brandId, seasonId) {
            if (brandId && brandId > 0 && seasonId && seasonId > 0) {

                LinePlanService.getLinePlansByBrandSeason(brandId, seasonId, 0).then(function (response) {
                    if (response) {
                        $scope.lineplans = response;
                    }
                });
            }
        };

        function getGenders() {
            //populate gender
            PatternService.getGenders("", 0).then(function (response) {
                if (response) {
                    $scope.genders = response;
                }
            });
        }

        function getFactories() {
            //populate division
            PrototypeService.getFactoryCodes().then(function (response) {
                if (response) {
                    $scope.factories = response;
                }
            });
        }

        function getDivisions() {
            //populate division
            PrototypeService.getDivisions(0).then(function (response) {
                if (response) {
                    $scope.divisions = response;
                }
            });
        }

        cfpLoadingBar.complete();

    }
}
)();
